import React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';

interface MenuLinkItemProps {
  href: string;
  name: string;
  analyticsName: string;
  isActive?: boolean;
  onPress?: () => void;
  showOnTablet?: boolean;
  tabletDisplay?: string;
  isLast?: boolean;
  icon?: React.ReactNode;
}

export const MenuLinkItem: React.FC<MenuLinkItemProps> = ({
  href,
  name,
  analyticsName,
  isActive,
  onPress,
  isLast,
  icon,
}) => {
  return (
    <Box
      tag="li"
      borderBottomWidth={isLast ? 0 : 1}
      borderColor="$borderPrimary"
      $largerThanSM={{ display: 'none' }}
    >
      <Link
        aria-current={isActive}
        href={href}
        analyticsName={analyticsName}
        onPress={onPress}
        display="inline-flex"
        alignItems="center"
        gap="$4x"
        paddingTop="$8x"
        paddingBottom="$8x"
        paddingLeft="$12x"
        paddingRight="$8x"
        backgroundColor={isActive ? '$backgroundStateHoverPrimary' : undefined}
      >
        {icon && (
          <Box width={20} height={20} alignItems="center" justifyContent="center">
            {icon}
          </Box>
        )}
        <Text tag="span" typography="$bodyMedium">
          {name}
        </Text>
      </Link>
    </Box>
  );
};
